export default __webpack_public_path__ + "static/121-1e425862fb681d06ee8754f455c5b2f9.jpg";